import { FormType } from './../enums/form.enum';
import { AlertService } from './../services/alert.service';
import { FormGroup, FormControl } from '@angular/forms';

export function ValidateFormFields(formGroup: FormGroup) {
  Object.keys(formGroup.controls).forEach(field => {
    const control = formGroup.get(field);
    if (control instanceof FormControl) {
      control.markAsTouched();
    } else if (control instanceof FormGroup) {
      ValidateFormFields(control);
    }
  });
}

export function clearFormErrors(formGroup: FormGroup) {
  formGroup.markAsPristine();
  formGroup.markAsUntouched();
  formGroup.updateValueAndValidity();
}

export function getFormValue(formGroup: FormGroup, prop: string) {
  if (!prop) {
    return formGroup.value;
  }
  return formGroup.get(prop).value;
}

export function CheckBeforeClose(
  alertSvc: AlertService,
  formType: FormType,
  confirmMsg = 'Se va a cerrar el formulario ¿Continuar?'
) {
  return new Promise(resolve => {
    if (formType !== FormType.CONSULTAR) {
      alertSvc.open(confirmMsg, null, { confirm: true }).then(confirm => {
        if (confirm) {
          resolve();
        }
      });
    } else {
      resolve();
    }
  });
}
